var map = {
	"./decidim/avatar-multiuser.png": 98223,
	"./decidim/brands/google.svg": 86198,
	"./decidim/cc-badge.png": 23557,
	"./decidim/decidim-logo.svg": 98589,
	"./decidim/default-avatar.svg": 78189,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 21075,
	"./decidim/icons.svg": 35260,
	"./decidim/pattern.png": 90079,
	"./decidim/placeholder-card-g.svg": 65732,
	"./decidim/placeholder-card-l.svg": 22559,
	"./decidim/placeholder.jpg": 95366,
	"./decidim/remixicon.symbol.svg": 27308,
	"./decidim/vendor/leaflet/layers-2x.png": 79029,
	"./decidim/vendor/leaflet/layers.png": 51116,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 26845,
	"./decidim/vendor/leaflet/marker-icon.png": 17604,
	"./decidim/vendor/leaflet/marker-shadow.png": 38683,
	"./decidim/vendor/social-share-button/douban.svg": 48831,
	"./decidim/vendor/social-share-button/email.svg": 15368,
	"./decidim/vendor/social-share-button/facebook.svg": 13556,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 76832,
	"./decidim/vendor/social-share-button/hacker_news.svg": 74220,
	"./decidim/vendor/social-share-button/linkedin.svg": 57326,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 75559,
	"./decidim/vendor/social-share-button/pinterest.svg": 74982,
	"./decidim/vendor/social-share-button/reddit.svg": 69692,
	"./decidim/vendor/social-share-button/telegram.svg": 44689,
	"./decidim/vendor/social-share-button/tumblr.svg": 82446,
	"./decidim/vendor/social-share-button/twitter.svg": 99301,
	"./decidim/vendor/social-share-button/vkontakte.svg": 58103,
	"./decidim/vendor/social-share-button/wechat.svg": 15330,
	"./decidim/vendor/social-share-button/whatsapp.svg": 18626,
	"./decidim/vendor/social-share-button/x.svg": 69864,
	"./decidim/vendor/social-share-button/xing.svg": 29888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1118;